import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=34679b5c&scoped=true"
import script from "./BaseView.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34679b5c",
  null
  
)

export default component.exports